/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes,extraRequire}
 * tslint:disable
 */
var styles = ["input.ng-invalid.ng-dirty[_ngcontent-%COMP%]{border-bottom-color:#e91e63!important;box-shadow:0 1px 0 0 #e91e63!important}button.btn-submit[_ngcontent-%COMP%]{width:100%}ul.answer[_ngcontent-%COMP%]   li[_ngcontent-%COMP%]:hover{background-color:#26a69a;color:#eafaf9;cursor:pointer}ul[_ngcontent-%COMP%]   li.selected[_ngcontent-%COMP%]{background-color:#26a69a!important;color:#eafaf9!important}"];
export { styles as styles };

